import type React from "react";

import { RequestStatusEnum } from "@nlc/shared-types";
import { PauseIcon, PlayIcon } from "lucide-react";

import { ConfirmationModal } from "@/components/confirmation-modal";
import { useEditRequestFormContext } from "@/features/request/edit/hooks/useEditRequestForm";
import { useTogglePause } from "@/features/request/edit/hooks/useTogglePause";

interface TogglePauseModalProps {
  isOpen: boolean;
  onOpenChange: React.Dispatch<React.SetStateAction<boolean>>;
}

export function TogglePauseModal({
  isOpen,
  onOpenChange,
}: TogglePauseModalProps) {
  const { pauseRequest } = useTogglePause();
  const { watch } = useEditRequestFormContext();

  const isResuming = watch("statusId") === RequestStatusEnum.Paused;

  const handleConfirm = () => {
    pauseRequest();
    onOpenChange(false);
  };

  return (
    <ConfirmationModal
      cancelButtonText="Discard"
      confirmButtonColor="color"
      confirmButtonText={isResuming ? "Resume request" : "Pause request"}
      icon={
        isResuming ? (
          <PlayIcon className="text-featured-icon-light-fg-success" />
        ) : (
          <PauseIcon className="text-featured-icon-light-fg-warning" />
        )
      }
      iconBackgroundClassName={
        isResuming ? "bg-bg-success-secondary" : "bg-bg-warning-secondary"
      }
      isOpen={isOpen}
      onConfirm={handleConfirm}
      onOpenChange={onOpenChange}
      text={
        isResuming
          ? "Resuming moves this to Scoping so your Design Lead can confirm we have what's needed. It'll be added at the end of your queue, you can reorder it anytime."
          : "Pausing stops work on this request. You can resume this request anytime."
      }
      title={isResuming ? "Resume request?" : "Pause request?"}
    />
  );
}
